import script from "./EditPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./EditPanel.vue?vue&type=script&setup=true&lang=js"

import "./EditPanel.vue?vue&type=style&index=0&id=36c3a9bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36c3a9bc"]])

export default __exports__